import { GameProps, gamePropsNull } from './game.props'
import { Game } from './game'
import { Bid } from './bid'

interface BiddingGameProps extends GameProps {
  readonly userBidOptions: Bid[]
  readonly shouldShowPassBidOption: boolean
}

export class BiddingGame extends Game {
  readonly shouldShowPassBidOption =
    this.biddingGameProps.shouldShowPassBidOption

  readonly userBidOptions = this.biddingGameProps.userBidOptions

  constructor(private biddingGameProps: BiddingGameProps) {
    super(biddingGameProps)
  }
}

export const biddingGameNull: BiddingGame = new BiddingGame({
  ...gamePropsNull,
  userBidOptions: [],
  shouldShowPassBidOption: false,
})
